import { namespaces } from '@common'

export const namespace = namespaces.insurance.value
export const schema = 'feeTableSchema'
export const backendDocType = 'FeeTable'
export const docPrivilege = 'insurance'
